import ExampleFileModal from "./ExampleFileModal";

export default ExampleFileModal;
